/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassLocationRef,
  ClassLocationRefOptional,
  ClassLocationRefMetaI,
  ClassLocationRefTrackedI,
} from "./class-location-ref";
import {
  ClassLocationRefTracked,
  ClassLocationRefMeta,
} from "./class-location-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceInternal,
  UnifiedClassInstanceInternalOptional,
  UnifiedClassInstanceInternalMetaI,
  UnifiedClassInstanceInternalTrackedI,
} from "./unified-class-instance-internal";
import {
  UnifiedClassInstanceInternalTracked,
  UnifiedClassInstanceInternalMeta,
} from "./unified-class-instance-internal";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionRef,
  UnifiedClassSessionRefOptional,
  UnifiedClassSessionRefMetaI,
  UnifiedClassSessionRefTrackedI,
} from "./unified-class-session-ref";
import {
  UnifiedClassSessionRefTracked,
  UnifiedClassSessionRefMeta,
} from "./unified-class-session-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeBase,
  UnifiedClassTypeBaseOptional,
  UnifiedClassTypeBaseMetaI,
  UnifiedClassTypeBaseTrackedI,
} from "./unified-class-type-base";
import {
  UnifiedClassTypeBaseTracked,
  UnifiedClassTypeBaseMeta,
} from "./unified-class-type-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithClassType,
  WithClassTypeOptional,
  WithClassTypeMetaI,
  WithClassTypeTrackedI,
} from "./with-class-type";
import { WithClassTypeTracked, WithClassTypeMeta } from "./with-class-type";

/**
 *
 * @export
 * @interface UnifiedClassInstanceWithType
 */
export interface UnifiedClassInstanceWithTypeOptional extends UnifiedClassInstanceInternalOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  signupMax?: number;
  /**
   *
   * @type {ClassLocationRef}
   * @memberof UnifiedClassInstanceWithType
   */
  locationId?: ClassLocationRefOptional;
  /**
   *
   * @type {Array<UnifiedClassSessionRef>}
   * @memberof UnifiedClassInstanceWithType
   */
  sessions?: UnifiedClassSessionRefOptional[];
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassInstanceWithType
   */
  instructorId?: PersonRefOptional;
  /**
   *
   * @type {Array<UnifiedClassSignupRef>}
   * @memberof UnifiedClassInstanceWithType
   */
  signups?: UnifiedClassSignupRefOptional[];
  /**
   *
   * @type {UnifiedClassTypeBase}
   * @memberof UnifiedClassInstanceWithType
   */
  typeId?: UnifiedClassTypeBaseOptional;
}

export interface UnifiedClassInstanceWithType
  extends
    UnifiedClassInstanceWithTypeOptional,
    UnifiedClassInstanceInternal,
    WithClassType {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  signupMax?: number;
  /**
   *
   * @type {ClassLocationRef}
   * @memberof UnifiedClassInstanceWithType
   */
  locationId?: ClassLocationRef;
  /**
   *
   * @type {Array<UnifiedClassSessionRef>}
   * @memberof UnifiedClassInstanceWithType
   */
  sessions?: UnifiedClassSessionRef[];
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassInstanceWithType
   */
  instructorId?: PersonRef;
  /**
   *
   * @type {Array<UnifiedClassSignupRef>}
   * @memberof UnifiedClassInstanceWithType
   */
  signups?: UnifiedClassSignupRef[];
  /**
   *
   * @type {UnifiedClassTypeBase}
   * @memberof UnifiedClassInstanceWithType
   */
  typeId?: UnifiedClassTypeBase;
}

export interface UnifiedClassInstanceWithTypeTrackedI extends UnifiedClassInstanceInternalOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassInstanceWithType
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
  /**
   *
   * @type {ClassLocationRef}
   * @memberof UnifiedClassInstanceWithType
   */
  locationId?: ClassLocationRefTrackedI;
  locationIdIsSet: boolean;
  /**
   *
   * @type {Array<UnifiedClassSessionRef>}
   * @memberof UnifiedClassInstanceWithType
   */
  sessions?: UnifiedClassSessionRefTrackedI[];
  sessionsIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassInstanceWithType
   */
  instructorId?: PersonRefTrackedI;
  instructorIdIsSet: boolean;
  /**
   *
   * @type {Array<UnifiedClassSignupRef>}
   * @memberof UnifiedClassInstanceWithType
   */
  signups?: UnifiedClassSignupRefTrackedI[];
  signupsIsSet: boolean;
  /**
   *
   * @type {UnifiedClassTypeBase}
   * @memberof UnifiedClassInstanceWithType
   */
  typeId?: UnifiedClassTypeBaseTrackedI;
  typeIdIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassInstanceWithType",
  function (model: UnifiedClassInstanceWithType) {
    const transformDateslocationId = transformDatesMap.get("ClassLocationRef");
    if (transformDateslocationId && model.locationId) {
      transformDateslocationId(model.locationId);
    }
    const transformDatessessions = transformDatesMap.get(
      "UnifiedClassSessionRef",
    );
    if (transformDatessessions) {
      model.sessions?.forEach((sub) => {
        transformDatessessions(sub);
      });
    }
    const transformDatesinstructorId = transformDatesMap.get("PersonRef");
    if (transformDatesinstructorId && model.instructorId) {
      transformDatesinstructorId(model.instructorId);
    }
    const transformDatessignups = transformDatesMap.get(
      "UnifiedClassSignupRef",
    );
    if (transformDatessignups) {
      model.signups?.forEach((sub) => {
        transformDatessignups(sub);
      });
    }
    const transformDatestypeId = transformDatesMap.get("UnifiedClassTypeBase");
    if (transformDatestypeId && model.typeId) {
      transformDatestypeId(model.typeId);
    }
  },
);

export type UnifiedClassInstanceWithTypeMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  locationId: PropertyMeta<ClassLocationRefMetaI>;
  //isDate: false
  //isDatetime: false
  sessions: PropertyMeta<UnifiedClassSessionRefMetaI>;
  //isDate: false
  //isDatetime: false
  instructorId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  signups: PropertyMeta<UnifiedClassSignupRefMetaI>;
  //isDate: false
  //isDatetime: false
  typeId: PropertyMeta<UnifiedClassTypeBaseMetaI>;
}>;

export var UnifiedClassInstanceWithTypeMeta: UnifiedClassInstanceWithTypeMetaI =
  {} as UnifiedClassInstanceWithTypeMetaI;
UnifiedClassInstanceWithTypeMeta = typeMeta("UnifiedClassInstanceWithType", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  locationId: propertyMeta(
    "locationId",
    false,
    false,
    false,
    ClassLocationRefMeta,
  ),
  sessions: propertyMeta(
    "sessions",
    true,
    false,
    false,
    UnifiedClassSessionRefMeta,
  ),
  instructorId: propertyMeta(
    "instructorId",
    false,
    false,
    false,
    PersonRefMeta,
  ),
  signups: propertyMeta(
    "signups",
    true,
    false,
    false,
    UnifiedClassSignupRefMeta,
  ),
  typeId: propertyMeta("typeId", false, false, false, UnifiedClassTypeBaseMeta),
});

const metaI = UnifiedClassInstanceWithTypeMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    UnifiedClassInstanceInternalMeta,
  ]);
  metaI.assignId.inheritedFrom = UnifiedClassInstanceInternalMeta.assignId;
  metaI.price.inheritedFrom = UnifiedClassInstanceInternalMeta.price;
  metaI.signupMax.inheritedFrom = UnifiedClassInstanceInternalMeta.signupMax;
  metaI.locationId.inheritedFrom = UnifiedClassInstanceInternalMeta.locationId;
  metaI.sessions.inheritedFrom = UnifiedClassInstanceInternalMeta.sessions;
  metaI.instructorId.inheritedFrom =
    UnifiedClassInstanceInternalMeta.instructorId;
  metaI.signups.inheritedFrom = UnifiedClassInstanceInternalMeta.signups;
  metaI.interfaces = metaI.interfaces.concat([WithClassTypeMeta]);
  metaI.typeId.inheritedFrom = WithClassTypeMeta.typeId;
});

export class UnifiedClassInstanceWithTypeTracked
  extends UnifiedClassInstanceInternalTracked
  implements UnifiedClassInstanceWithTypeTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  locationId__I?: ClassLocationRefTracked = undefined;
  locationIdIsSet: boolean = false;
  set locationId(v: undefined | ClassLocationRefTracked) {
    if (v !== undefined) {
      this.locationId__I = v;
      this.locationIdIsSet = true;
    } else {
      this.locationId__I = v || undefined;
      this.locationIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get locationId() {
    return this.locationId__I;
  }
  sessions__I?: UnifiedClassSessionRefTracked[] = undefined;
  sessionsIsSet: boolean = false;
  set sessions(v: undefined | UnifiedClassSessionRefTracked[]) {
    if (v !== undefined) {
      this.sessions__I = v;
      this.sessionsIsSet = true;
    } else {
      this.sessions__I = v || undefined;
      this.sessionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessions() {
    return this.sessions__I;
  }
  instructorId__I?: PersonRefTracked = undefined;
  instructorIdIsSet: boolean = false;
  set instructorId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.instructorId__I = v;
      this.instructorIdIsSet = true;
    } else {
      this.instructorId__I = v || undefined;
      this.instructorIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructorId() {
    return this.instructorId__I;
  }
  signups__I?: UnifiedClassSignupRefTracked[] = undefined;
  signupsIsSet: boolean = false;
  set signups(v: undefined | UnifiedClassSignupRefTracked[]) {
    if (v !== undefined) {
      this.signups__I = v;
      this.signupsIsSet = true;
    } else {
      this.signups__I = v || undefined;
      this.signupsIsSet = false;
    }
    this.changeTracker = true;
  }
  get signups() {
    return this.signups__I;
  }
  typeId__I?: UnifiedClassTypeBaseTracked = undefined;
  typeIdIsSet: boolean = false;
  set typeId(v: undefined | UnifiedClassTypeBaseTracked) {
    if (v !== undefined) {
      this.typeId__I = v;
      this.typeIdIsSet = true;
    } else {
      this.typeId__I = v || undefined;
      this.typeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeId() {
    return this.typeId__I;
  }
  constructor(
    config?: UnifiedClassInstanceWithTypeOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.locationId?.setIds();

    this.sessions?.forEach((a) => a.setIds());
    this.instructorId?.setIds();

    this.signups?.forEach((a) => a.setIds());
    this.typeId?.setIds();
  }
  assignFrom(
    config: UnifiedClassInstanceWithTypeOptional,
    options?: AssignOptions,
  ): UnifiedClassInstanceWithTypeTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (
      config.locationId &&
      this.locationIdApplyFilter(optionsRequired.filter)
    ) {
      this.locationId = new ClassLocationRefTracked(config.locationId, options);
      if (optionsRequired.unassign) this.locationIdIsSet = false;
      else this.locationIdIsSet = true;
    }
    if (config.sessions && this.sessionsApplyFilter(optionsRequired.filter)) {
      this.sessions = config.sessions?.map(
        (a) => new UnifiedClassSessionRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.sessionsIsSet = false;
      else this.sessionsIsSet = true;
    }
    if (
      config.instructorId &&
      this.instructorIdApplyFilter(optionsRequired.filter)
    ) {
      this.instructorId = new PersonRefTracked(config.instructorId, options);
      if (optionsRequired.unassign) this.instructorIdIsSet = false;
      else this.instructorIdIsSet = true;
    }
    if (config.signups && this.signupsApplyFilter(optionsRequired.filter)) {
      this.signups = config.signups?.map(
        (a) => new UnifiedClassSignupRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.signupsIsSet = false;
      else this.signupsIsSet = true;
    }
    if (config.typeId && this.typeIdApplyFilter(optionsRequired.filter)) {
      this.typeId = new UnifiedClassTypeBaseTracked(config.typeId, options);
      if (optionsRequired.unassign) this.typeIdIsSet = false;
      else this.typeIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassInstanceWithTypeTrackedI {
    const cloned = {} as UnifiedClassInstanceWithTypeTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    if (
      this.locationIdIsSetDeep() &&
      this.locationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationIdIsSet = true;
      cloned.locationId = this.locationId?.removeUnset(filter);
    } else {
      //cloned.locationIdIsSet = false
    }
    if (
      this.sessionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.sessionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionsIsSet = true;
      cloned.sessions = this.sessions
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.sessionsIsSet = false
    }
    if (
      this.instructorIdIsSetDeep() &&
      this.instructorIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorIdIsSet = true;
      cloned.instructorId = this.instructorId?.removeUnset(filter);
    } else {
      //cloned.instructorIdIsSet = false
    }
    if (
      this.signupsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.signupsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupsIsSet = true;
      cloned.signups = this.signups
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.signupsIsSet = false
    }
    if (
      this.typeIdIsSetDeep() &&
      this.typeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIdIsSet = true;
      cloned.typeId = this.typeId?.removeUnset(filter);
    } else {
      //cloned.typeIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassInstanceWithTypeTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    if (!this.locationIdApplyFilter(filter)) this.locationIdIsSet = false;
    this.locationId?.unassignAll(filter);

    if (!this.sessionsApplyFilter(filter)) this.sessionsIsSet = false;

    this.sessions?.forEach((a) => a.unassignAll(filter));
    if (!this.instructorIdApplyFilter(filter)) this.instructorIdIsSet = false;
    this.instructorId?.unassignAll(filter);

    if (!this.signupsApplyFilter(filter)) this.signupsIsSet = false;

    this.signups?.forEach((a) => a.unassignAll(filter));
    if (!this.typeIdApplyFilter(filter)) this.typeIdIsSet = false;
    this.typeId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.assignId,
      UnifiedClassInstanceWithTypeMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.price,
      UnifiedClassInstanceWithTypeMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.signupMax,
      UnifiedClassInstanceWithTypeMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  locationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.locationId,
      UnifiedClassInstanceWithTypeMeta,
      this.locationId,
      this,
    );
  }
  locationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationIdIsSet && this.locationIdApplyFilter(filter)) return true;
    return this.locationId?.anySet(filter) == true;

    return false;
  }
  sessionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.sessions,
      UnifiedClassInstanceWithTypeMeta,
      this.sessions,
      this,
    );
  }
  sessionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionsIsSet && this.sessionsApplyFilter(filter)) return true;

    return this.sessions?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  instructorIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.instructorId,
      UnifiedClassInstanceWithTypeMeta,
      this.instructorId,
      this,
    );
  }
  instructorIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instructorIdIsSet && this.instructorIdApplyFilter(filter))
      return true;
    return this.instructorId?.anySet(filter) == true;

    return false;
  }
  signupsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.signups,
      UnifiedClassInstanceWithTypeMeta,
      this.signups,
      this,
    );
  }
  signupsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupsIsSet && this.signupsApplyFilter(filter)) return true;

    return this.signups?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassInstanceWithTypeMeta.typeId,
      UnifiedClassInstanceWithTypeMeta,
      this.typeId,
      this,
    );
  }
  typeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIdIsSet && this.typeIdApplyFilter(filter)) return true;
    return this.typeId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    if (this.locationIdIsSetDeep(filter)) return true;
    if (this.sessionsIsSetDeep(filter)) return true;
    if (this.instructorIdIsSetDeep(filter)) return true;
    if (this.signupsIsSetDeep(filter)) return true;
    if (this.typeIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
